import { render, staticRenderFns } from "./ProjectGeneralSubmissionForm.vue?vue&type=template&id=72f9206c"
import script from "./ProjectGeneralSubmissionForm.vue?vue&type=script&lang=js"
export * from "./ProjectGeneralSubmissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports